import { render, staticRenderFns } from "./RevisionModal.vue?vue&type=template&id=23b3db69&scoped=true"
import script from "./RevisionModal.vue?vue&type=script&lang=js"
export * from "./RevisionModal.vue?vue&type=script&lang=js"
import style0 from "./RevisionModal.vue?vue&type=style&index=0&id=23b3db69&prod&scoped=true&lang=css"
import style1 from "./RevisionModal.vue?vue&type=style&index=1&id=23b3db69&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b3db69",
  null
  
)

export default component.exports